// TermsOfService.jsx - Estatica Skin and Laser
import React, { useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import MyNavbar from "../../components/customer/myNavbar/MyNavbar";
import Footer from "../../components/customer/footer/Footer";
import "../../assets/css/components/legalpages/Legalpages.css";

const sections = [
  { id: "accounts", title: "Accounts & Eligibility" },
  { id: "appointments", title: "Appointments & Bookings" },
  { id: "treatments", title: "Treatments & Health Disclosure" },
  { id: "deals", title: "Deals, Offers & Payments" },
  { id: "cancellation", title: "Cancellation & Refund Policy" },
  { id: "acceptable-use", title: "Acceptable Use" },
  { id: "ip", title: "Intellectual Property" },
  { id: "liability", title: "Limitation of Liability" },
  { id: "changes", title: "Changes to These Terms" },
  { id: "law", title: "Governing Law" },
  { id: "contact", title: "Contact Us" },
];

const TermsOfService = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <MyNavbar />
      <section className="es-legal-page">
        <Container>
          {/* Hero */}
          <div className="es-legal-hero">
            <p className="es-legal-label">Legal</p>
            <h1 className="es-legal-heading">Terms of Service</h1>
            <div className="es-legal-accent" />
            <span className="es-legal-updated">
              Last updated: <span className="es-legal-fill">[8/24/2026]</span>
            </span>
          </div>

          <div className="es-legal-layout">
            <Row>
              {/* Sticky TOC sidebar */}
              <Col lg={3}>
                <div className="es-legal-sidebar">
                  <p className="es-legal-toc-title">On this page</p>
                  <ul className="es-legal-toc">
                    {sections.map((s, i) => (
                      <li key={s.id}>
                        <a href={`#${s.id}`}>
                          {i + 1}. {s.title}
                        </a>
                      </li>
                    ))}
                  </ul>
                </div>
              </Col>

              {/* Content */}
              <Col lg={9}>
                <div className="es-legal-content">
                  <p className="es-legal-intro">
                    Welcome to Estetica Skin & Laser. These Terms of Service
                    ("Terms") govern your access to and use of our website and
                    the services available through the platform, including
                    treatment information, appointment booking, deals and
                    offers, and customer account features. By creating an
                    account, booking an appointment, or otherwise using our
                    platform, you agree to be bound by these Terms. If you do
                    not agree, please do not use our platform.
                  </p>

                  {/* 1. Eligibility & Accounts */}
                  <div className="es-legal-section" id="accounts">
                    <h2 className="es-legal-section-title">
                      <span className="es-legal-badge">1</span> Accounts &amp;
                      Eligibility
                    </h2>
                    <p className="es-legal-text">
                      You must be at least 18 years old, or have the consent of
                      a parent or legal guardian, to book a treatment with us.
                      When you create an account, you agree to provide accurate,
                      current, and complete information and to keep it updated.
                    </p>
                    <p className="es-legal-text">
                      You are responsible for maintaining the confidentiality of
                      your login credentials and for all activity that occurs
                      under your account. Notify us immediately if you suspect
                      unauthorized use of your account.
                    </p>
                  </div>

                  {/* 2. Appointments & Bookings */}
                  <div className="es-legal-section" id="appointments">
                    <h2 className="es-legal-section-title">
                      <span className="es-legal-badge">2</span> Appointments
                      &amp; Bookings
                    </h2>
                    <p className="es-legal-text">
                      Appointments booked through our platform are requests and
                      are subject to confirmation by our team. A booking is only
                      considered confirmed once its status is marked "Approved"
                      in your account.
                    </p>
                    <ul className="es-legal-list">
                      <li>
                        Please arrive on time for your appointment. Late
                        arrivals may result in a shortened session or the need
                        to reschedule.
                      </li>
                      <li>
                        We reserve the right to reschedule or cancel an
                        appointment due to staff availability, equipment issues,
                        or other operational reasons, and will notify you as
                        soon as possible.
                      </li>
                      <li>
                        You may cancel or request to reschedule an appointment
                        through your account. Repeated last-minute cancellations
                        or no-shows may result in restrictions on future
                        bookings.
                      </li>
                    </ul>
                  </div>

                  {/* 3. Treatments & Health Disclosure */}
                  <div className="es-legal-section" id="treatments">
                    <h2 className="es-legal-section-title">
                      <span className="es-legal-badge">3</span> Treatments &amp;
                      Health Disclosure
                    </h2>
                    <p className="es-legal-text">
                      Treatment information displayed on our platform is
                      provided for general informational purposes. Customers
                      should review the treatment details, duration, and other
                      available information before booking an appointment.
                    </p>
                    <p className="es-legal-text">
                      Treatment results may vary from person to person. Any
                      treatment-related guidance and aftercare instructions will
                      be provided by the clinic where applicable.
                    </p>
                  </div>

                  {/* 4. Deals, Offers & Payments */}
                  <div className="es-legal-section" id="deals">
                    <h2 className="es-legal-section-title">
                      <span className="es-legal-badge">4</span> Deals, Offers
                      &amp;
                    </h2>
                    <p className="es-legal-text">
                      Promotional deals and discounts are subject to the
                      validity period, terms, and availability stated at the
                      time of the offer. Deals may be modified or withdrawn by
                      the clinic when necessary. Claimed deals are
                      non-transferable unless otherwise stated.
                    </p>
                    <p className="es-legal-text">
                      Prices for treatments and services are displayed on the
                      platform at the time of booking and may be subject to
                      change. Appointment details and availability will be
                      confirmed at the time of booking.
                    </p>
                  </div>

                  {/* 5. Cancellation & Refund Policy */}
                  <div className="es-legal-section" id="cancellation">
                    <h2 className="es-legal-section-title">
                      <span className="es-legal-badge">5</span> Cancellation
                     
                    </h2>
                    <p className="es-legal-text">
                      {/* <span className="es-legal-fill"> */}
                        Customers may cancel or request to reschedule an
                        appointment through the platform before the scheduled
                        appointment time. Customers are encouraged to inform the
                        clinic as early as possible when they need to cancel or
                        reschedule an appointment so that the appointment slot
                        can be made available to other customers.
                      {/* </span> */}
                    </p>
                  </div>

                  {/* 6. Acceptable Use */}
                  <div className="es-legal-section" id="acceptable-use">
                    <h2 className="es-legal-section-title">
                      <span className="es-legal-badge">6</span> Acceptable Use
                    </h2>
                    <p className="es-legal-text">You agree not to:</p>
                    <ul className="es-legal-list">
                      <li>
                        Use the Services for any unlawful purpose or in
                        violation of any applicable regulation.
                      </li>
                      <li>
                        Submit false, misleading, or fraudulent booking or
                        account information.
                      </li>
                      <li>
                        Attempt to gain unauthorized access to our systems,
                        other users' accounts, or non-public areas of the
                        platform.
                      </li>
                      <li>
                        Interfere with or disrupt the integrity or performance
                        of the Services.
                      </li>
                      <li>
                        Copy, reproduce, or resell any part of our content or
                        Services without permission.
                      </li>
                    </ul>
                  </div>

                  {/* 7. Intellectual Property */}
                  <div className="es-legal-section" id="ip">
                    <h2 className="es-legal-section-title">
                      <span className="es-legal-badge">7</span> Intellectual
                      Property
                    </h2>
                    <p className="es-legal-text">
                      All content on our website — including text, graphics,
                      logos, images, and software — is the property of Estetica
                      Skin &amp; Laser or its licensors and is protected by
                      applicable intellectual property laws. You may not use our
                      branding or content without prior written consent.
                    </p>
                  </div>

                  {/* 8. Limitation of Liability */}
                  <div className="es-legal-section" id="liability">
                    <h2 className="es-legal-section-title">
                      <span className="es-legal-badge">8</span> Limitation of
                      Liability
                    </h2>
                    <p className="es-legal-text">
                      To the fullest extent permitted by law, Estetica Skin
                      &amp; Laser shall not be liable for any indirect,
                      incidental, or consequential damages arising from your use
                      of the Services, except in cases of gross negligence or
                      willful misconduct on our part. Nothing in these Terms
                      limits liability that cannot be excluded under applicable
                      law.
                    </p>
                  </div>

                  {/* 9. Changes to These Terms */}
                  <div className="es-legal-section" id="changes">
                    <h2 className="es-legal-section-title">
                      <span className="es-legal-badge">9</span> Changes to These
                      Terms
                    </h2>
                    <p className="es-legal-text">
                      We may update these Terms from time to time. When we do,
                      we will revise the "Last updated" date above and, for
                      material changes, provide reasonable notice through the
                      website or app. Continued use of the Services after
                      changes take effect constitutes acceptance of the revised
                      Terms.
                    </p>
                  </div>

                  {/* 10. Governing Law */}
                  <div className="es-legal-section" id="law">
                    <h2 className="es-legal-section-title">
                      <span className="es-legal-badge">10</span> Governing Law
                    </h2>
                    <p className="es-legal-text">
                      These Terms are governed by and interpreted in accordance
                      with the laws of the Islamic Republic of Pakistan.
                      {/* <span className="es-legal-fill">
                       These Terms and Conditions shall be governed by and interpreted in accordance with the laws of the Islamic Republic of Pakistan.

                      </span> */}
                      , without regard to conflict-of-law principles.
                    </p>
                  </div>

                  {/* 11. Contact */}
                  <div className="es-legal-section" id="contact">
                    <h2 className="es-legal-section-title">
                      <span className="es-legal-badge">11</span> Contact Us
                    </h2>
                    <div className="es-legal-contact-box">
                      <p className="es-legal-contact-name">
                        Estetica Skin &amp; Laser
                      </p>

                      <div className="es-legal-contact-row">
                        <span className="es-legal-contact-icon">
                          <svg
                            width="15"
                            height="15"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="1.8"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          >
                            <path d="M21 10c0 7-9 13-9 13S3 17 3 10a9 9 0 1 1 18 0z" />
                            <circle cx="12" cy="10" r="3" />
                          </svg>
                        </span>
                        <span className="es-legal-fill">
                          22A, Block A, Satellite Town, Gujranwala
                        </span>
                      </div>

                      <div className="es-legal-contact-row">
                        <span className="es-legal-contact-icon">
                          <svg
                            width="15"
                            height="15"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="1.8"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          >
                            <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                            <polyline points="22,6 12,13 2,6" />
                          </svg>
                        </span>
                        <a href="mailto:info@esteticaskinlaser.com">
                          info@esteticaskinlaser.com
                        </a>
                      </div>

                      <div className="es-legal-contact-row">
                        <span className="es-legal-contact-icon">
                          <svg
                            width="15"
                            height="15"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="1.8"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          >
                            <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z" />
                          </svg>
                        </span>
                        <span className="es-legal-fill">+92 311 1133023</span>
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </Container>
      </section>
      <Footer />
    </>
  );
};

export default TermsOfService;
